import type React from "react";

import { cn } from "@krea/shared/utils";

import type { IFIIdentityProvider } from "../types";

interface BankItemProps {
  bank: IFIIdentityProvider;
  onClick: () => void;
}

const BankItem: React.FC<BankItemProps> = ({ bank, onClick }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        "cursor-pointer flex flex-col items-center rounded-sm border-2 border-gray-200 bg-white",
        " p-4 shadow-sm transition-all duration-200",
        "hover:border-primary hover:shadow-lg focus:outline-hidden focus:ring-2 focus:ring-primary focus:ring-offset-2",
      )}
      aria-label={`Select ${bank.name}`}
    >
      <div className="mb-2 flex h-16 w-full items-center justify-center">
        <img
          src={bank.imageUrl}
          alt={bank.name}
          className="max-h-full max-w-full object-contain"
        />
      </div>
      <span className="text-center text-label">{bank.name}</span>
    </button>
  );
};

interface BankSelectorProps {
  banks: IFIIdentityProvider[];
  onSelect: (ftnIdpId: string) => void;
  className?: string;
}

export const BankSelector: React.FC<BankSelectorProps> = ({
  banks,
  onSelect,
  className = "",
}) => {
  return (
    <div className={`grid grid-cols-2 gap-4 md:grid-cols-3 ${className}`}>
      {banks.map((bank) => (
        <BankItem
          key={bank.ftnIdpId}
          bank={bank}
          onClick={() => onSelect(bank.ftnIdpId)}
        />
      ))}
    </div>
  );
};
